import { render, staticRenderFns } from "./AppContentWrapper.vue?vue&type=template&id=c18c32b8"
import script from "./AppContentWrapper.vue?vue&type=script&lang=js"
export * from "./AppContentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports